// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"RecipientValidationPriceTable_tableHeader__7k+uv"};